const CompletedIconGreen = ({ ...props }) => (
	<svg
		{...props}
		width="20"
		height="20"
		viewBox="0 0 9 9"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.73858 1.02192C2.96158 1.02192 1.52103 2.46246 1.52103 4.23947C1.52103 6.01647 2.96158 7.45702 4.73858 7.45702C6.51559 7.45702 7.95613 6.01647 7.95613 4.23947C7.95613 2.46246 6.51559 1.02192 4.73858 1.02192ZM0.716644 4.23947C0.716644 2.01821 2.51733 0.217529 4.73858 0.217529C6.95984 0.217529 8.76052 2.01821 8.76052 4.23947C8.76052 6.46072 6.95984 8.2614 4.73858 8.2614C2.51733 8.2614 0.716644 6.46072 0.716644 4.23947ZM6.22956 3.15069C6.38662 3.30775 6.38662 3.56241 6.22956 3.71947L4.62078 5.32825C4.46372 5.48532 4.20906 5.48532 4.05199 5.32825L3.24761 4.52386C3.09054 4.36679 3.09054 4.11214 3.24761 3.95507C3.40467 3.79801 3.65933 3.79801 3.81639 3.95507L4.33639 4.47507L5.66077 3.15069C5.81784 2.99362 6.07249 2.99362 6.22956 3.15069Z"
			fill="#33DF64"
		/>
	</svg>
)

export default CompletedIconGreen
